import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild } from '@angular/core';
import { PDFDocumentProxy, PdfViewerComponent } from 'ng2-pdf-viewer';

@Component({
  selector: 'app-fax-pages-previews',
  templateUrl: './fax-pages-previews.component.html',
  styleUrls: ['./fax-pages-previews.component.scss']
})
export class FaxPagesPreviewsComponent {
  @Input() src = "";
  @Input() page = 1;
  @Input() columns: 2 | 4 = 2;

  @Output() selectPage = new EventEmitter<number>();
  @Output() loadComplete = new EventEmitter<number>();

  constructor() {}

  pageRendered() {   
    // this.pdfComponent.pdfViewer.currentScaleValue = 'page-fit';
  }

  // The only way to get page number from PdfViewerComponent
  pageChanged(events: PointerEvent) {

    const eventTarget = events.composedPath().find(x => this.checkIsElementAtPage(x));
    const htmlElement = eventTarget as HTMLElement;

    if (htmlElement == null || htmlElement.dataset == null) {
      throw new Error("unknown HtmlElement");
    }

    const pageNumber = Number(htmlElement.dataset.pageNumber);

    if (isNaN(pageNumber)) {
      throw new Error("invalid page number");
    }

    this.selectPage.emit(pageNumber);
  }

  onLoadComplete(pdf: PDFDocumentProxy) {
    this.loadComplete.emit(pdf._pdfInfo.numPages);
  }

  private checkIsElementAtPage(eventTarget: EventTarget) {
    const htmlElement = eventTarget as Element;

    if (htmlElement == null) {
      return false;
    }

    return htmlElement.classList.contains("page");
  }
}
